import { useEffect } from 'react';
import { internalLog } from '@ecom-zform/core';
import { useChangeFormError } from './use-change-form-error';
/**
 * 当组件卸载时，自动将 value, error 设置为 undefined
 * @param form
 * @param disable
 */
export function useAutoDelete(form, disable) {
    if (disable === void 0) { disable = true; }
    useChangeFormError(form, 'useAutoDelete');
    useEffect(function () {
        return function () {
            /**
             * record:
             * 是否能支持表单变更？
             * 当 cacheForm.current === form.uuid 时，才是真正的卸载，这样实现可以么？
             * 不行啊，如果将表单 a -> b，那如果表单 a 被卸载了怎么办？
             */
            if (!disable) {
                form.setState({
                    value: undefined,
                    error: undefined,
                }, internalLog('auto delete remove value', form));
            }
        };
    }, [form.uuid]);
}
